module.exports = __webpack_public_path__ + "static/media/compliance--mobile--en.7c2cfd63.png";